import { HeartBank } from "../../../managers/HeartBank.ts";
import { Scanner } from "./Scanner.ts";
import { B3 } from "../../../models/3B.ts";
import { QrCode } from "../../../models/QrCode.ts";
import { Chest, Chests } from "../../../models/Chests.ts";
import { Me } from "../../../managers/Me.ts";
import { Locker } from "../hb-silver/Locker.ts";
import { Crypto as CryptoLocker } from "../../../models/Crypto.ts";
import { Crypto as CryptoSafe } from "../../../managers/Crypto.ts";
import { Stamps } from "../../../models/Stamps.ts";

import template from "./hb-mine.mjs";
import { render } from "lit-html";
import {
    HB,
    B,
    isRunningAsPWA,
    pickFile,
    VAULT,
    wait,
    getDeviceID,
    APP,
    fetchBlob,
    redirect
} from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { Jewelry } from "../../../models/Diamonds.ts";
import { Chest as Manager } from "../../../managers/Chest.ts";

// b-chest image types
// gif: static and beating // imported
// png: for copying and pasting // maybe imported too
// webp: scanned

export class HbMine extends Scanner {
    private heartbank: HeartBank = new HeartBank();
    private stamps = new Stamps();
    private cryptoLocker = new CryptoLocker();
    private cryptoSafe = new CryptoSafe();
    private locker = new Locker();
    private me = new Me();
    private chests = new Chests();
    private qr = new QrCode();
    private B3 = new B3();
    private did = getDeviceID();
    private modal: ModalInterface;

    private mine: HTMLElement;
    private reset: HTMLButtonElement;
    private switch: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private import: HTMLButtonElement;
    private message: HTMLElement;

    private zoom: HTMLElement;
    private zoomLevel: HTMLInputElement;
    private zoomMin: HTMLSpanElement;
    private zoomMax: HTMLSpanElement;
    private zoomMid: HTMLSpanElement;

    private stamp: HTMLElement;
    private link: HTMLButtonElement;
    private unlink: HTMLButtonElement;

    private chest: HTMLElement;
    private chestTitle: HTMLParagraphElement;
    private chestAvatar: HTMLImageElement;
    private chestType: HTMLSpanElement;
    private chestDiamonds: HTMLSpanElement;
    private chestFrom: HTMLSpanElement;
    private chestTo: HTMLSpanElement;
    private chestKarat: HTMLSpanElement;
    private chestTime: HTMLParagraphElement;

    private heading: HTMLHeadingElement;
    private close: HTMLButtonElement;
    private info: HTMLParagraphElement;

    // reset on show
    private color = "gray";
    private url = "";
    private data = "";
    private diamonds: Array<File> = [];
    private code: Blob | null = null; // if not url: store imported image or scanned image to dexie chests
    private cloudChestID = ""; // don't reset on show in order for linking

    private readonly retryMessage = " Tap to try mining again.";

    constructor() {
        super();

        this.mine = this.querySelector("#hb-mine")!;
        this.reset = this.querySelector("#hb-mine-reset")!;
        this.switch = this.querySelector("#hb-mine-switch")!;
        this.paste = this.querySelector("#hb-mine-paste")!;
        this.import = this.querySelector("#hb-mine-import")!;
        this.message = this.querySelector("#hb-mine-message")!;

        this.zoom = this.querySelector("#hb-mine-zoom")!;
        this.zoomLevel = this.querySelector("#hb-mine-zoom-level")!;
        this.zoomMin = this.querySelector("#hb-mine-zoom-min")!;
        this.zoomMax = this.querySelector("#hb-mine-zoom-max")!;
        this.zoomMid = this.querySelector("#hb-mine-zoom-mid")!;

        this.stamp = this.querySelector("#hb-mine-stamp")!;
        this.link = this.querySelector("#hb-mine-stamp-link")!;
        this.unlink = this.querySelector("#hb-mine-stamp-unlink")!;

        this.chest = this.querySelector("#hb-mine-chest")!;
        this.chestTitle = this.querySelector("#hb-mine-chest-title")!;
        this.chestAvatar = this.querySelector("#hb-mine-chest-avatar")!;
        this.chestType = this.querySelector("#hb-mine-chest-type")!;
        this.chestDiamonds = this.querySelector("#hb-mine-chest-diamonds")!;
        this.chestFrom = this.querySelector("#hb-mine-chest-from")!;
        this.chestTo = this.querySelector("#hb-mine-chest-to")!;
        this.chestKarat = this.querySelector("#hb-mine-chest-karat")!;
        this.chestTime = this.querySelector("#hb-mine-chest-time")!;

        this.heading = this.querySelector("#hb-mine-title")!;
        this.close = this.querySelector("#hb-mine-close")!;
        this.info = this.querySelector("#hb-mine-info")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: false, // so user can't close while mining in progress
            onHide: () => {
                this.video.pause();
                //this.stopScanner();
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-mine",
            override: true
        };

        this.modal = new Modal(this.mine, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.reset.addEventListener("click", this.resetCamera.bind(this));
        this.switch.addEventListener("click", this.toggleCamera.bind(this));
        this.paste.addEventListener("click", this.minePaste.bind(this));
        this.import.addEventListener("click", this.mineImport.bind(this));
        this.close.addEventListener("click", () => {
            this.stopScanner();
            window.location.hash = "#";
        });

        this.video.addEventListener("click", () => (this.video.muted = false));

        this.unlink.addEventListener("click", () => {
            if (
                confirm(
                    "Are you sure you want to un-link the B-Stamp you scanned?"
                )
            ) {
                localStorage.removeItem("stamp");
                this.renderStamp();
            }
        });

        //TODO: later separate message depending on if stamp is first or chest is first
        this.link.addEventListener("click", async () => {
            if (
                confirm(
                    "Would you like to link this Silver B-Chest to the Silver B-Stamp you scanned?"
                )
            ) {
                await this.stamps.link(
                    localStorage.getItem("stamp")!,
                    this.heartbank.user!.uid,
                    this.cloudChestID,
                    true
                );
                const stamps = await this.stamps.stampCount(
                    this.heartbank.user!.uid,
                    this.cloudChestID
                );

                localStorage.removeItem("stamp");
                this.cloudChestID = "";
                await this.renderStamp();
                this.resetCamera();

                alert(
                    `You have successfully linked ${stamps} Silver B-Stamp${
                        stamps === 1 ? "" : "s"
                    } to this Silver B-Chest.`
                );
            }
        });

        //this.cam and this.canvas conflicts with zoom slider
        [this.stamp, this.chest].forEach((element) => {
            element.addEventListener("click", () => {
                if (this.url) {
                    this.hide(); // to turn off camera
                    const url = new URL(this.url);
                    if (this.url.startsWith(B)) {
                        //const searchParams = new URLSearchParams(url.search); // remove all other params??
                        url.searchParams.set("origin", "vault"); // vault web app, b-mail app, b-secret app, b-note app
                        window.location.href = url.toString();
                    } else if (this.url.startsWith(APP)) {
                        window.location.hash = url.hash;
                    } else {
                        this.animateStamp(false);
                        this.animateChest(false);
                        this.openWindow(url.toString());
                    }
                } else if (this.data) this.preMine(this.data);
            });
        });

        this.addScannerListeners();

        this.heartbank.addAuthStateListener((hero) => {
            render(template(hero), this);
        });
    }

    private async renderStamp() {
        const stamp = localStorage.getItem("stamp");
        const isStamp = stamp && !(await this.stamps.isMinted(stamp));
        if (isStamp && this.cloudChestID && this.heartbank.user) {
            this.link.classList.remove("hidden");
            this.unlink.classList.add("hidden");
            this.unlink.classList.remove("inline-flex");
        } else {
            this.link.classList.add("hidden");
            this.unlink.classList.toggle("hidden", !isStamp);
            this.unlink.classList.toggle("inline-flex", !!isStamp);
        }
    }

    private animateStamp(isShow: boolean) {
        this.stamp.classList.toggle("hidden", !isShow);
        this.stamp.classList.toggle("opacity-0", !isShow);
        this.stamp.classList.toggle("opacity-80", !!isShow);
        // isShow
        //     ? this.stamp.classList.replace("opacity-0", "opacity-80")
        //     : this.stamp.classList.replace("opacity-80", "opacity-0");
    }

    private animateChest(isShow: boolean) {
        this.chest.classList.toggle("hidden", !isShow);
        this.chest.classList.toggle("opacity-0", !isShow);
        this.chest.classList.toggle("opacity-80", !!isShow);
        // isShow
        //     ? this.chest.classList.replace("opacity-0", "opacity-80")
        //     : this.chest.classList.replace("opacity-80", "opacity-0");
    }

    restart() {
        this.heading.textContent = "HeartBank® Mining ℹ️";
        this.renderInfo("Now mining for HeartBank® Chest or Stamp...");
        this.color = "gray";
        this.url = "";
        this.data = "";
        this.diamonds = [];
        this.code = null;
        this.animateStamp(false); // doesn't work in show()
        this.animateChest(false); // doesn't work in show()
    }

    // TODO: show spinner if await is too long
    async show(id: string) {
        this.restart();
        this.renderStamp();
        this.modal.show();

        this.toggle(true);
        const turnOnCamera = await this.validateCloud(id);
        if (turnOnCamera) {
            this.toggle(false);
            this.renderZoom();
            await this.initScanner();
            this.startScanner();
        }
    }

    hide() {
        this.modal.hide();
    }

    private renderZoom() {
        const zoom = this.getZoomCapabilities();
        if (zoom) {
            this.zoomLevel.min = zoom.min;
            this.zoomLevel.max = zoom.max;
            this.zoomLevel.step = zoom.step;
            this.zoomLevel.value = "2";

            this.zoomMin.textContent = zoom.min + "x";
            this.zoomMax.textContent = zoom.max + "x";
            this.zoomMid.textContent = (zoom.min + zoom.max) / 2 + "x";

            this.zoomLevel.oninput = (e: any) =>
                this.setZoom(parseFloat(e.target.value));
        }
        this.zoom.classList.toggle("hidden", !zoom);
    }

    private toggle(isHidden: boolean) {
        this.video.classList.toggle("hidden", !isHidden);
        this.canvas.classList.toggle("hidden", isHidden);

        this.heading.innerHTML = isHidden ? "" : "HeartBank® Mining ℹ️";
        this.close.classList.toggle("invisible", isHidden); // hidden conflicts with isPwa
        //this.zoom.classList.toggle("hidden", isHidden);
        this.info.classList.toggle("hidden", isHidden);

        const footer = this.querySelector("#hb-mine-footer") as HTMLElement;
        footer.classList.toggle("hidden", isHidden);
    }

    private openWindow(link: string, amount: number | null = null) {
        const params = new URLSearchParams(window.location.search);
        const lang = params.get("lang") || "en";

        const url = new URL(link);
        url.searchParams.append("lang", lang);
        url.searchParams.append("origin", isRunningAsPWA ? "pwa" : "web");
        if (amount) url.searchParams.append("amount", amount.toString());

        const popup = window.open(url.toString(), "_blank");
        if (!popup) window.location.assign(url.toString()); //alert(strings.popup[lang]);
    }

    private async resetCamera() {
        await this.initScanner();
        this.restart();
    }

    private toggleCamera() {
        this.animateStamp(false);
        this.animateChest(false);
        // Toggle facingMode
        if (this.currentFacingMode === "environment") {
            this.currentFacingMode = "user";
            this.switch.textContent = "Back Camera";
        } else {
            this.currentFacingMode = "environment";
            this.switch.textContent = "Front Camera";
        }
        this.initScanner();
    }

    private renderInfo(message: string) {
        this.message.style.color = "gray";
        this.message.textContent = message;
    }

    private renderWarning(message: string | null = null) {
        this.message.style.color = "orange";
        this.message.textContent =
            message ||
            "Be careful, this is NOT an authentic HeartBank® Chest or Stamp!";
    }

    private renderError(message: string) {
        this.message.style.color = "red";
        this.message.textContent = message;
    }

    // mine

    private addScannerListeners() {
        // If scanning hard: Tap on qr code to change to black for better scanning??? Try to solve with better algorithm??
        this.addEventListener("qr-detected", async (event: Event) => {
            const customEvent = event as CustomEvent;
            //console.log("QR Code detected: ", customEvent.detail);
            const { data, image } = customEvent.detail;
            this.code = await fetchBlob(image);
            this.preMine(data);
        });

        // TODO: how to hide chest smoothly ?? // prob just button to reset cam
        this.addEventListener("none-detected", () => {
            //if (!this.code) this.chest.classList.add("hidden");
        });

        this.addEventListener("qr-error", (event: Event) => {
            const customEvent = event as CustomEvent;
            //console.error("QR Scanner Error: ", customEvent.detail);
            this.message.textContent = customEvent.detail;
        });
    }

    private async minePaste() {
        this.animateStamp(false);
        this.animateChest(false);
        const url = await this.getUrlFromClipboard();
        if (url) this.preMine(url);
        else {
            try {
                const qr = await this.qr.mineClipboard();
                if (qr) {
                    this.code = qr.blob;
                    this.preMine(qr.data);
                } else {
                    const crystal = await this.B3.mineClipboard();
                    if (crystal) {
                        this.diamonds = crystal.diamonds;
                        this.preMine(crystal.data);
                    } else this.renderWarning();
                }
            } catch (error: any) {
                this.renderError(error.message);
            }
        }
    }

    private async getUrlFromClipboard(): Promise<string | null> {
        try {
            const text = await navigator.clipboard.readText();
            try {
                const url = new URL(text.trim());
                //console.log("Valid URL:", url.href);
                return url.href;
            } catch {
                //console.log("Clipboard content is not a valid URL");
                return null;
            }
        } catch (err) {
            //console.error("Failed to read clipboard:", err);
            return null;
        }
    }

    private async mineImport() {
        this.animateStamp(false);
        this.animateChest(false);
        try {
            const file = await pickFile({
                accept: ".B.gif,.B.png,image/*,.3B.glb,.3B.usdz,.glb,.usdz" // ,model/*
            });
            if (file) {
                if (
                    // qr code image
                    file.name.endsWith(".B.gif") ||
                    file.name.endsWith(".B.png") ||
                    file.type.startsWith("image/")
                ) {
                    const data = await this.qr.mineFile(file);
                    this.code = file;
                    this.preMine(data);
                } else if (
                    // android crystal
                    file.name.endsWith(".3B.glb") ||
                    file.name.endsWith(".glb")
                    //|| file.type.startsWith("model/")
                ) {
                    const { data, diamonds } = await this.B3.mine2(file);
                    this.diamonds = diamonds;
                    this.preMine(data);
                } else if (
                    // ios crystal
                    file.name.endsWith(".3B.usdz") ||
                    file.name.endsWith(".usdz")
                    //|| file.type.startsWith("model/")
                ) {
                    const { data, diamonds } = await this.B3.mine(file);
                    this.diamonds = diamonds;
                    this.preMine(data);
                } else {
                    this.renderWarning();
                }
            }
        } catch (error: any) {
            this.renderError(error.message);
        }
    }

    private preMine(data: string | null) {
        console.log(data);
        if (data?.startsWith("https://") || data?.startsWith("http://")) {
            if (this.url !== data) {
                this.animateStamp(false);
                this.animateChest(false);
            }

            this.url = data;
            this.validateUrl();
        } else if (data?.startsWith("B:/")) {
            // not needed bc no preview for local chest
            //this.cloudChestID = "";
            //await this.renderStamp();

            this.message.style.color = "gray";
            this.message.textContent =
                "HeartBank® Silver Chest detected. Mining now...";
            this.data = data;
            this.validateData();
        } else {
            this.renderWarning();
        }
    }

    ///// validate

    // digital b-chests: b.333.eco/x/id => #/mine/id => #/chest/id/mine
    // physical b-metals: b.333.eco/x/id => #/mine/id?vendorData => #/mint/step/id OR #/chest/id
    // physical b-stamps: b.333.eco/x/id => #/mine/id?vendorData => #/stamp/id OR #/chest/id
    private async validateUrl() {
        const url = new URL(this.url ?? "");
        if (url.hostname === "b.333.eco" || url.hostname === "id.333.eco" || url.hostname === "127.0.0.1") {
            let product;
            const paths = url.pathname.split("/");
            const gem = paths[1];
            const id = paths[2];
            //console.log(paths);

            switch (gem) {
                // VAULT
                // digital: always redirect to b for stats => then redirect to vault.333.eco
                case "v": // silver
                    product = "Silver Chest";
                    this.color = "silver";
                    break;
                // physical: always redirect to b for stats => then redirect to vault.333.eco
                case "s": // silver // MEDIUM
                    product = "Silver Stamp";
                    this.color = "silver";
                    break;
                case "x": // demo: silver b-stamp
                    product = "Silver Stamp";
                    this.color = "silver";
                    break;

                // TROVE
                // digital: redirect to trove.333.eco
                case "t": // rainbow gold based on kiitos = carat
                    product = "Gold Chest";
                    this.color = "gold";
                    break;
                // physical: redirect to trove.333.eco
                case "d": // gold // SMALL
                    product = "Gold Stamp";
                    this.color = "gold";
                    break;

                // RAINBOW B-STAMP
                // physical: redirect to dedicated thank app
                case "r": // thank.hb.com MEDIUM
                    product = "Red Stamp";
                    this.color = "crimson";
                    break;
                case "o": // thank.hb.org MEDIUM
                    product = "Orange Stamp";
                    this.color = "orangered";
                    break;
                case "y": // thank.hb.us LARGE
                    product = "Yellow Stamp";
                    this.color = "gold";
                    break;
                case "g": // thank.333.eco MEDIUM
                    product = "Green Stamp";
                    this.color = "greenyellow"; //forestgreen
                    break;
                case "b": // thank.hb.net MEDIUM
                    product = "Blue Stamp";
                    this.color = "aquamarine";
                    break;
                case "i": // thank.hb.me LARGE
                    product = "Indigo Stamp";
                    this.color = "darkorchid";
                    break;
                case "v": // thank.hb.ceo MEDIUM
                    product = "Violet Stamp";
                    this.color = "deeppink";
                    break;
            }

            const status = await this.renderChest(gem, id);
            if (product && status !== "error") {
                this.message.style.color = this.color;
                if (status === "blank") {
                    if (this.heartbank.user) {
                        const heartkeysCount = parseInt(
                            localStorage.getItem("heartkeysCount") || "0"
                        );
                        if (heartkeysCount) {
                            //const { protocol, host } = window.location;
                            //this.url = `${protocol}//${host}/#/mint/ship`;
                            this.url = APP + "/#/mint/ship";
                            this.message.textContent = `A brand new HeartBank® ${product} is detected. Tap to mint it!`;
                        } else if (
                            confirm(
                                "A Safe is required to mint a HeartBank® Stamp.\n\nWould you like to create one now?"
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-safes",
                                window.location.hash
                            );
                            window.location.hash = "#/safes";
                        } else this.url = "";
                    } else {
                        if (
                            confirm(
                                "You need to be logged in to mint a HeartBank® Stamp.\n\nWould you like to log in now?"
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-login",
                                window.location.hash
                            );
                            window.location.hash = "#/login";
                        } else this.url = "";
                    }
                } else
                    this.message.textContent = `HeartBank® ${product} detected. Tap to mine it!`;
            } else {
                this.cloudChestID = "";
                await this.renderStamp();
                this.message.style.color = "red";
                this.message.textContent = `Be careful, this ${product} is NOT authentic!`;
            }
        } else {
            this.cloudChestID = "";
            await this.renderStamp();
            this.renderWarning();
            this.message.textContent += " Tap to open link anyway.";
        }
    }

    // can just process here but will redirect to B for now
    private async renderChest(
        gem: string,
        id: string
    ): Promise<"blank" | "success" | "error"> {
        let chest;
        switch (gem) {
            case "x":
                const stamp = await this.stamps.get(id);
                if (stamp) {
                    await this.stamps.addMiner(
                        this.heartbank.user?.uid || "",
                        stamp.id!
                    );
                    if (stamp.chest) {
                        chest = await this.chests.getCloud(stamp.chest);
                        break;
                    } else {
                        localStorage.setItem("storage", "cloud");
                        localStorage.setItem("stamp", stamp.id!); // needed so user can save draft
                        this.animateStamp(true);
                        this.renderStamp();
                        redirect("mine");
                        return "blank";
                    }
                } else return "error";
            case "v":
                chest = await this.chests.getCloud(id);
                break;
        }

        if (chest) {
            const data = JSON.parse(
                decodeURIComponent(chest.data.split("/")[1])
            );

            const karat = this.chestKarat.parentElement
                ?.lastElementChild as HTMLSpanElement;
            this.chestTitle.textContent = chest.name;
            this.chestKarat.textContent = data.b.w || 0;
            karat.textContent = data.n.v ? "Karat Gold" : "Karat Silver";
            this.chestDiamonds.innerHTML = `💎 <span class="text-base ml-2">${
                data.b.d || 0
            }</span>`;

            const manager = new Manager(chest, data);
            const from = this.chestFrom.parentElement
                ?.firstElementChild as HTMLParagraphElement;
            const to = this.chestTo.parentElement
                ?.firstElementChild as HTMLParagraphElement;
            const countdown = this.querySelector(
                "#hb-mine-timelock"
            ) as HTMLElement;

            if (manager.isTimeLocked()) {
                this.chestAvatar.removeAttribute("src");
                to.textContent = "🔒 TIME LOCK";
                this.chestTo.textContent = "";
                from.textContent = `UNTIL:`;
                this.chestFrom.innerHTML =
                    manager.timelock?.toFormattedString() || "";
                this.chestTime.textContent = "";

                this.chestType.innerHTML = `<span class="text-base mr-2">$$$</span> ${
                    data.b.e === 1 ? "🫆" : data.n.e ? "🔒" : "🌐"
                }`;

                const [days, hours, minutes] =
                    manager.timelock?.countdown() ?? [0, 0, 0];
                countdown.innerHTML = `
                    <div class="flex flex-col gap-1 p-5">
                        <div>
                            <span class="font-mono text-4xl">${days}</span>
                            day${days === 1 ? "" : "s"}
                        </div>
                        <div>
                            <span class="font-mono text-4xl">${hours}</span>
                            hour${hours === 1 ? "" : "s"}
                        </div>
                        <div>
                            <span class="font-mono text-4xl">${minutes}</span>
                            minute${minutes === 1 ? "" : "s"}
                        </div>
                    </div>
                `;
            } else {
                from.textContent = "From:";
                to.textContent = "To:";
                countdown.innerHTML = "";

                this.chestType.innerHTML = `<span class="text-base mr-2">${(
                    data.g?.a || 0
                ).toCashAmount()}</span> ${
                    data.b.e === 1 ? "🫆" : data.n.e ? "🔒" : "🌐"
                }`;

                this.chestAvatar.src = chest.avatar as unknown as string;
                this.chestFrom.innerHTML = `${await this.me.getName(
                    data.f.p
                )} <span class="font-normal">at</span> ${data.l.n}`;
                this.chestTo.textContent = await this.me.getNames(data.t);
                this.chestTime.textContent = chest.date.timeAgo();
                //console.log(chest.date.toISOString());
            }

            await this.chests.incrementDigs(chest.id);
            //this.animateChest(false); // weird bug
            //await wait(1000); // weird bug
            this.animateChest(true);
            this.cloudChestID = chest.id;
            await this.renderStamp();
            return "success";
        }

        return "error";
    }

    // local b-chest: no preview for now TODO: later add preview?
    private async validateData() {
        const hash = await this.cryptoLocker.hash(this.data);

        // check if already minted
        const chest1 = await this.chests.getByHash(hash, "mint");
        if (chest1) {
            this.renderWarning("You have already minted this B-Chest.");
            await wait(2);
            window.location.hash = `#/chest/${chest1.id}/mints`;
            return;
        }

        // check if already mined
        const chest2 = await this.chests.getByHash(hash, "mine");
        if (chest2) {
            this.renderWarning("You have already mined this B-Chest.");
            await wait(2);
            window.location.hash = `#/chest/${chest2.id}/mine`;
            return;
        }

        // checking below is redundant but keep for clarity

        const paths = this.data.split("/");
        const data = JSON.parse(decodeURIComponent(paths[1]));

        const stockCategory = paths[2];
        const stockItem = paths[3];
        const coverPoster = `${VAULT}/${stockCategory}/${stockItem}/${stockItem}.jpg`;
        const coverVideo = `${VAULT}/${stockCategory}/${stockItem}/${stockItem}.mp4`;

        // store
        // possible for third party to mint via mining!!!
        // TODO: later need to make sure they follow B protocol
        const results = await this.validate(data);
        if (results) {
            const { isFromMe, location, silver, trove, voice } = results;
            if (isFromMe) {
                const chest = await this.chests.getByHash(hash, "mint");
                if (chest) {
                    this.renderWarning("You have already minted this B-Chest.");
                    await wait(1);
                    window.location.hash = `#/chest/${chest.id}/mints`;
                } else {
                    this.store(
                        "mint",
                        data.f.p,
                        location,
                        trove,
                        silver,
                        voice,
                        coverPoster,
                        coverVideo
                    );
                }
            } else {
                const chest = await this.chests.getByHash(hash, "mine");
                if (chest) {
                    this.renderWarning("You have already mined this B-Chest.");
                    await wait(1);
                    window.location.hash = `#/chest/${chest.id}/mine`;
                } else {
                    this.store(
                        "mine",
                        data.f.p,
                        location,
                        trove,
                        silver,
                        voice,
                        coverPoster,
                        coverVideo
                    );
                }
            }
        }
    }

    private async store(
        type: "mint" | "mine",
        fromPublicKey: string,
        location: { a: string; t: number; g: number } | null,
        trove: Jewelry[] | null,
        silver: string | null,
        voice: { l?: string; f?: File } | null,
        coverPoster: string,
        coverVideo: string
    ) {
        const ship = prompt(
            "What name would you like to assign to this Silver B-Chest?"
        );
        if (ship) {
            this.renderInfo(
                "Now storing a backup copy of this Silver B-Chest inside your Titanium Vault..."
            );
            const id = await this.chests.mint(
                ship,
                this.heartbank.user?.uid || "",
                this.data,
                fromPublicKey,
                location,
                silver,
                coverPoster,
                coverVideo,
                type
            );
            if (this.code) await this.chests.update(id, this.code);
            if (trove) await this.storeTrove(id, trove);
            if (voice) await this.storeVoice(id, voice);
            await wait(2);
            window.location.hash = `#/chest/${id}/mine`;
        } else {
            this.renderWarning("Mining was cancelled." + this.retryMessage);
        }
    }

    private async storeTrove(id: string, trove: Jewelry[]) {
        for (const jewelry of trove) await this.chests.addDiamond(id, jewelry);
    }

    private async storeVoice(id: string, voice: { l?: string; f?: File }) {
        await this.chests.updateVoice(id, voice);
    }

    // allow anyone to open public chest ?? yes for posting publicly to social networks
    private async validate(data: any) {
        // first: verify signatures
        // 1: verify from signature of data
        // 2: verify hb signature of "from signature"

        const name = (await this.me.getUserName(data.f.p)) || "Sender";

        this.renderInfo(`Now verifying signature of ${name}...`);
        const isVerified = await this.locker.verifyFrom(data);
        await wait(2);
        if (!isVerified) {
            this.renderError(
                `${name}'s signature is not valid.` + this.retryMessage
            );
            await wait(2);
            return null;
        }

        if (data.b.s) {
            this.renderInfo(`Now verifying humanity of ${name}...`);
            const isVerified = await this.locker.verifyHumanity(data);
            await wait(2);
            if (HB.vault !== data.b.p || !isVerified) {
                this.renderError(
                    "HeartBank's signature is not valid." + this.retryMessage
                );
                await wait(2);
                return null;
            }
        }

        // second: get symmetric key if encrypted

        const isHumanityRequired = data.b.e === 1;
        let symmetricKey = "";

        // is humanity required
        if (isHumanityRequired) {
            this.renderInfo(`Now verifying your humanity with passkey...`);
            //await wait(2);
            if (this.heartbank.user) {
                const response = await this.cryptoSafe.get(
                    false,
                    data.b.p,
                    data.b.k
                );
                if (response.color === "green")
                    symmetricKey = response.decryptedContent!;
                else {
                    this.renderWarning(
                        "Passkey is required to prove your humanity. Please try again."
                    );
                    await wait(2);
                    return null;
                }
            } else {
                this.renderWarning(
                    "Only humans can open this B-Chest. Please login first to prove your humanity. Then try again."
                );
                await wait(2);
                return null;
            }
        }

        /// from: sender can open his own b-chest

        let isFromMe = false,
            fromAddressType = await this.me.getFromAddressType2(
                data.f.p,
                this.heartbank.user?.uid || null
            ),
            isValidFrom: boolean | null = null; // does user have private key?

        if (fromAddressType === "locker") {
            isFromMe = true;
            if (data.f.k && !symmetricKey) {
                const id = await this.me.getLocker(data.f.p); // should always exist
                symmetricKey = await this.cryptoLocker.decryptSymmetricKey2(
                    id!,
                    data.f.k
                );
                isValidFrom = !!symmetricKey;
            } else isValidFrom = await this.cryptoLocker.isValid2(data.f.p);
        } else if (fromAddressType === "safe") {
            isFromMe = true;
            if (data.f.k && !symmetricKey && this.heartbank.user) {
                const response = await this.cryptoSafe.get(
                    true,
                    data.f.p,
                    data.f.k
                );
                if (response.color === "green") {
                    symmetricKey = response.decryptedContent!;
                    isValidFrom = true;
                }
            } else isValidFrom = false; // TODO: call server to check
        }

        // to

        let toPublicKey = "",
            toAddressType: "locker" | "safe" | null = null,
            isValidTo: boolean | null = null; // does user have private key?

        if (data.t) {
            const recipient = await this.getRecipient(data.t);
            if (recipient) {
                const encryptedSymmetricKey = recipient.encryptedSymmetricKey;
                toAddressType = recipient.isLocker ? "locker" : "safe";
                toPublicKey = recipient.publicKey;

                if (encryptedSymmetricKey && !symmetricKey) {
                    if (toAddressType === "locker") {
                        const id = await this.me.getLocker(toPublicKey);
                        if (id) {
                            symmetricKey =
                                await this.cryptoLocker.decryptSymmetricKey2(
                                    id,
                                    encryptedSymmetricKey
                                );
                            isValidTo = await this.cryptoLocker.isValid2(
                                recipient.publicKey
                            );
                        } else
                            isValidTo = await this.cryptoLocker.isValid2(
                                recipient.publicKey
                            );
                    }

                    if (toAddressType === "safe" && this.heartbank.user) {
                        const response = await this.cryptoSafe.get(
                            true,
                            toPublicKey,
                            encryptedSymmetricKey
                        );
                        if (response.color === "green") {
                            symmetricKey = response.decryptedContent!;
                            isValidTo = true;
                        } else {
                            isValidTo = false; //TODO: call server to check
                        }
                    }
                }
            }
        }

        // check

        const isEncrypted = !!data.b.i;
        const errorMessage =
            "Sorry, a valid private key is required to open this B-Chest.";
        const retryMessage = this.heartbank.user
            ? ""
            : " Try logging first. Then tap here to mine again.";

        // should always pass
        if (!isHumanityRequired && isEncrypted && isFromMe && !isValidFrom) {
            this.renderError(errorMessage + retryMessage);
            await wait(2);
            return null;
        }

        // should always pass
        if (!isHumanityRequired && isEncrypted && toPublicKey && !isValidTo) {
            this.renderError(errorMessage + retryMessage);
            await wait(2);
            return null;
        }

        // public can open but cannot read encrypted data
        // important last check: symmetric key should exist
        // if (isEncrypted && !symmetricKey)
        //     if (isEncrypted && !symmetricKey) {
        //         this.renderError(
        //             "Sorry, this Silver B-Chest is not intended for you." +
        //                 retryMessage
        //         );
        //         await wait(2);
        //         return null;
        //     }

        // decrypt

        const hasPermission = isFromMe || toPublicKey;
        const isLocal = data.b.v !== 0;

        let location: any = null,
            trove: any = null,
            silver = null,
            voice: any = null;

        if (data.l.h && symmetricKey) {
            if (hasPermission || (!data.l.e && isHumanityRequired)) {
                this.renderInfo(
                    `Now decrypting ${name}'s location coordinates...`
                );
                if (isLocal) {
                    location = {};
                    location.a = await this.cryptoLocker.decrypt2(
                        symmetricKey,
                        data.b.i,
                        data.l.a
                    );
                    location.t = await this.cryptoLocker.decrypt2(
                        symmetricKey,
                        data.b.i,
                        data.l.t
                    );
                    location.g = await this.cryptoLocker.decrypt2(
                        symmetricKey,
                        data.b.i,
                        data.l.g
                    );
                }
            } else {
                this.renderInfo(
                    `Sorry, ${name} did you grant you permission to view the location coordinates...`
                );
            }
            await wait(2);
        }

        if (data.n.h && symmetricKey) {
            if (hasPermission || (!data.n.e && isHumanityRequired)) {
                this.renderInfo(`Now decrypting ${name}'s message...`);
                if (isLocal) {
                    silver = await this.cryptoLocker.decrypt2(
                        symmetricKey,
                        data.b.i,
                        data.n.m
                    );
                    if (data.n.v) {
                        voice = {}; //l,f
                        if (data.n.v.l)
                            voice.l = await this.cryptoLocker.decrypt2(
                                symmetricKey,
                                data.b.i,
                                data.n.v.l
                            );
                        if (data.n.v.n && data.n.v.h) {
                            const file = await this.validateFile(
                                data.n.v.n,
                                data.n.v.h
                            );
                            voice.f = file
                                ? await this.cryptoLocker.decryptFile(
                                      file,
                                      symmetricKey,
                                      data.b.i,
                                      data.n.v.n
                                  )
                                : undefined;
                        }
                    }
                }
            } else {
                this.renderInfo(
                    `Sorry, ${name} did you grant you permission to view the message...`
                );
            }
            await wait(2);
        } else if (isLocal && data.n.v) {
            voice = {}; //l,f
            if (data.n.v.l) voice.l = data.n.v.l;
            if (data.n.v.n && data.n.v.h)
                voice.f = await this.validateFile(data.n.v.n, data.n.v.h);
        }

        if (data.d && data.d.h && symmetricKey) {
            if (hasPermission || (!data.d.e && isHumanityRequired)) {
                this.renderInfo(`Now decrypting ${name}'s Diamonds...`);
                if (isLocal) {
                    //encrypt: s,n,i,l,f
                    trove = [];
                    for (const diamond of data.d.m) {
                        const jewelry: any = {};
                        jewelry.s = diamond.s;
                        jewelry.n = diamond.n;
                        if (diamond.i)
                            jewelry.i = await this.cryptoLocker.decrypt2(
                                symmetricKey,
                                data.b.i,
                                diamond.i
                            );
                        if (diamond.l)
                            jewelry.l = await this.cryptoLocker.decrypt2(
                                symmetricKey,
                                data.b.i,
                                diamond.l
                            );
                        if (diamond.h) {
                            const file = await this.validateFile(
                                diamond.n,
                                diamond.h
                            );
                            jewelry.f = file
                                ? await this.cryptoLocker.decryptFile(
                                      file,
                                      symmetricKey,
                                      data.b.i,
                                      diamond.n
                                  )
                                : undefined;
                        }
                        trove.push(jewelry);
                    }
                }
            } else {
                this.renderInfo(
                    `Sorry, ${name} did you grant you permission to view the Diamonds...`
                );
            }
            await wait(2);
        } else if (isLocal && data.d) {
            // not encrypted: s,n,i,l,f
            trove = [];
            for (const diamond of data.d.m) {
                const jewelry: any = {};
                jewelry.s = diamond.s;
                jewelry.n = diamond.n;
                if (diamond.i) jewelry.i = diamond.i;
                if (diamond.l) jewelry.l = diamond.l;
                if (diamond.h)
                    jewelry.f = await this.validateFile(diamond.n, diamond.h);
                trove.push(jewelry);
            }
        }

        return {
            isFromMe,
            toPublicKey,
            toAddressType,

            location,
            trove,
            silver,
            voice
        };
    }

    // file doesn't exist or is corrupted
    private async validateFile(
        name: string,
        hash: string
    ): Promise<File | undefined> {
        const file = this.diamonds.find((d) => d.name === name);
        if (file) {
            return hash === (await this.cryptoLocker.hashFile(file))
                ? file
                : undefined;
        }
        return undefined;
    }

    private async getRecipient(recipients: any): Promise<{
        isLocker: boolean;
        publicKey: string;
        encryptedSymmetricKey: string | null;
    } | null> {
        for (const recipient of recipients) {
            const locker = await this.me.getLocker(recipient.p);
            if (locker)
                return {
                    isLocker: true,
                    publicKey: recipient.p,
                    encryptedSymmetricKey: recipient.k || null
                };
            else {
                if (this.heartbank.user) {
                    const safe = await this.me.getSafe(
                        this.heartbank.user.uid,
                        recipient.p
                    );
                    if (safe)
                        return {
                            isLocker: false,
                            publicKey: recipient.p,
                            encryptedSymmetricKey: recipient.k || null
                        };
                }
            }
        }
        return null;
    }

    private playCoverArt(chest: Chest, data: any) {
        this.renderInfo("Now opening this Silver B-Chest...");

        const manager = new Manager(chest, data);
        const cash = data.g?.a || 0;
        const heading = cash
            ? (manager.isTimeLocked() ? "$$$" : cash.toCashAmount()) + " • "
            : "";

        this.heading.innerHTML = `
            <svg
                aria-hidden="true"
                class="inline mr-3 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
            ${heading}${chest.name}
        `;

        this.video.src = chest.coverVideo;
        this.video.poster = chest.coverPoster;
        //this.video.playsInline = true;
        this.video.muted = true;
        this.video.loop = true;
        //this.video.controls = false;
        this.video.autoplay = true;
        //this.video.play();
    }

    // cloud b-chest: validate url part 2
    private async validateCloud(id: string): Promise<boolean> {
        if (id) {
            const chest = await this.chests.getCloud(id);
            if (chest) {
                const paths = chest.data.split("/");
                const data = JSON.parse(decodeURIComponent(paths[1]));
                this.playCoverArt(chest, data);
                await wait(3); // for user to enjoy cover art

                // check for time lock
                const manager = new Manager(chest, data);
                if (manager.isTimeLocked()) {
                    alert(
                        `Sorry, this B-Chest is time-locked. Please try mining again after ${manager.timelock?.toFormattedString()}.`
                    );
                    return true;
                }

                // check if already minted: not possible to re-mint cloud chest
                // check if already mined
                if (this.heartbank.user) {
                    if (
                        chest.uid === this.heartbank.user.uid ||
                        chest.users?.includes(this.heartbank.user.uid)
                    ) {
                        this.renderWarning(
                            `You have already ${
                                chest.uid === this.heartbank.user.uid
                                    ? "minted"
                                    : "mined"
                            } this B-Chest...`
                        );
                        await wait(2);
                        window.location.hash = `#/chest/${id}/${
                            chest.uid === this.heartbank.user.uid
                                ? "mints"
                                : "mines"
                        }`;
                        return false;
                    }
                } else {
                    if (chest.devices?.includes(this.did)) {
                        this.renderWarning(
                            "You have already mined this B-Chest..."
                        );
                        await wait(2);
                        window.location.hash = `#/chest/${id}/mines`;
                        return false;
                    }
                }
                // checking below is redundant but keep for clarity

                // store
                const results = await this.validate(data);
                if (results) {
                    const { toPublicKey, toAddressType } = results;

                    if (toPublicKey && !chest.recipients?.includes(toPublicKey))
                        await this.chests.addRecipient(id, toPublicKey);

                    if (toAddressType === "locker") {
                        if (chest.devices?.includes(this.did)) {
                            this.renderWarning(
                                "You have already mined this Silver B-Chest..."
                            );
                            await wait(2);
                            window.location.hash = `#/chest/${id}/mines`;
                        } else {
                            this.renderInfo(
                                "Now mining this Silver B-Chest and storing it inside your Cloud Vault..."
                            );
                            await this.chests.addDevice(id, this.did);
                            await wait(2);
                            window.location.hash = `#/chest/${id}/mine`;
                        }
                    } else if (toAddressType === "safe") {
                        if (this.heartbank.user) {
                            if (
                                chest.uid === this.heartbank.user.uid ||
                                chest.users?.includes(this.heartbank.user.uid)
                            ) {
                                this.renderWarning(
                                    `You have already ${
                                        chest.uid === this.heartbank.user.uid
                                            ? "minted"
                                            : "mined"
                                    } this B-Chest...`
                                );
                                await wait(2);
                                window.location.hash = `#/chest/${id}/${
                                    chest.uid === this.heartbank.user.uid
                                        ? "mints"
                                        : "mines"
                                }`;
                            } else {
                                // TODO: make user do passkey first ??? pro no
                                this.renderInfo(
                                    "Now mining this Silver B-Chest and storing it inside your Cloud Vault..."
                                );
                                await this.chests.addUser(
                                    id,
                                    this.heartbank.user.uid // user must be logged in to mine b-chest stored in the cloud
                                );
                                await wait(2);
                                window.location.hash = `#/chest/${id}/mine`;
                            }
                        } else {
                            this.renderInfo(
                                "To mine this Silver B-Chest, please login first. Then try again."
                            );
                            await wait(2);
                            window.location.hash = `#/chest/${id}/mine`;
                        }
                    } else window.location.hash = `#/chest/${id}/mining`;
                } else window.location.hash = `#/chest/${id}/mining`;

                // stats // need to come last!
                if (this.heartbank.user)
                    this.chests.addMiner(id, this.heartbank.user.uid);
                else this.chests.addDigger(id, this.did);

                return false;
            } else this.renderError("This B-Chest is not authentic.");
        }
        return true;
    }
}
